import { Collection } from 'modules/core/lib/mobx-rest'

import Dashboard from 'modules/reports/store/models/Dashboard'

class Dashboards extends Collection<Dashboard> {
  get cacheKey(): string {
    return 'dashboards'
  }

  model() {
    return Dashboard
  }
}

const singleton: Dashboards = new Dashboards()

export default singleton
